<div class="card overflow-hidden shadow-sm rounded-4 border h-100">
  <div class="card-body d-flex flex-column h-100">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h2 class="fw-500 mb-0 fs-24">Available Co Buyers</h2>
    </div>

    <!-- Search -->
    <div class="position-relative mb-3">
      <svg-icon
        [name]="'search-topbar'"
        class="position-absolute top-50 translate-middle-y ms-3 svg-24 svg-primary"
      ></svg-icon>
      <input
        class="form-control form-control-lg ps-5 rounded-5"
        type="text"
        placeholder="co-buyer name or email"
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)"
      />
    </div>

    <!-- Co-Buyer List -->
    <div class="bg-light mx-n3 d-flex flex-column flex-fill gap-3 overflow-y-auto p-3 mb-n3">
      @for (coBuyer of filteredCoBuyers(); track coBuyer.id) {
        <div class="product-card border p-3 cursor-pointer position-relative">
          <div class="d-flex gap-3 align-items-start">
            <div class="flex-fill">
              <div class="d-flex justify-content-between align-items-start">
                <h5 class="fw-500 mb-1">{{ getFullName(coBuyer) }}</h5>
                @if (canWriteDeals()) {
                  <button
                    class="stretched-link px-2 btn btn-primary rounded-3 btn-sm d-flex align-items-center gap-2 btn-h35 ms-auto"
                    (click)="onLinkCoBuyer(coBuyer)"
                  >
                    <i class="bi bi-link-45deg lh-1"></i>
                    <span>Link</span>
                  </button>
                }
              </div>
              @if (coBuyer.email) {
                <p class="text-muted small mb-0">{{ coBuyer.email }}</p>
              }
              @if (coBuyer.phone?.phoneNumber) {
                <p class="text-muted small mb-0">{{ coBuyer?.phone?.phoneNumber }}</p>
              }
            </div>
          </div>
        </div>
      }

      @if (filteredCoBuyers().length === 0) {
        <div class="d-flex flex-column align-items-center justify-content-center gap-2 h-100">
          <i class="bi bi-person-plus fs-48 text-gray-300"></i>
          <p class="mb-0 fs-20 text-gray-300 text-center">
            @if (searchQuery()) {
              No co-buyers found.
            } @else {
              No co-buyers available.
            }
          </p>
        </div>
      }
    </div>
  </div>
</div>
